import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { UPCOnlineSetting } from '~/models/administration/upcOnlineSetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class UPCOnlineSettingsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.settings);
    }

    getUPCOnlineSettings() {
        return this.http.get<UPCOnlineSetting>(this._url());
    }

    updateUPCOnlineSettings(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/UPCOnlineSettings${v}`);
    }
}
